"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initAuthentication;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _utils = require("../common/utils");
var _addStatesHandle = _interopRequireDefault(require("./addStatesHandle"));
var _excluded = ["name", "addRequestKeys", "requestKeys", "addRequestKeysForAdmin", "requestKeysForAdmin"],
  _excluded2 = ["name", "addIfThereIsNot"];
function initAuthentication() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  var client = wapp.client;
  var lastRequest = null;
  wapp.middleware.addHandle({
    user: function user(req, res, next) {
      var _lastRequest, _lastRequest$user;
      if (!lastRequest) {
        var _initialState$req;
        var appStateName = res.wappResponse.appStateName;
        var initialState = window[appStateName];
        lastRequest = {
          user: ((_initialState$req = initialState.req) === null || _initialState$req === void 0 ? void 0 : _initialState$req.user) || null
        };
      }
      if ((_lastRequest = lastRequest) !== null && _lastRequest !== void 0 && (_lastRequest$user = _lastRequest.user) !== null && _lastRequest$user !== void 0 && _lastRequest$user._id) {
        req.wappRequest.user = lastRequest.user;
        req.user = req.wappRequest.user;
      }
      lastRequest = req.wappRequest;
      next();
    }
  });
  if (!client.authentications) {
    var defaultAuthenticationsObject = Object.create(Object.prototype, {
      addAuthentication: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        writable: false,
        enumerable: false,
        value: function addAuthentication() {
          var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _p$name = p.name,
            name = _p$name === void 0 ? "user" : _p$name,
            addRequestKeys = p.addRequestKeys,
            requestKeys = p.requestKeys,
            addRequestKeysForAdmin = p.addRequestKeysForAdmin,
            requestKeysForAdmin = p.requestKeysForAdmin,
            rest = (0, _objectWithoutProperties2["default"])(p, _excluded);
          var postType = wapp.client.postTypes.getPostType((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rest), {}, {
            name: name,
            addIfThereIsNot: true,
            config: {
              requiredDataForStatus: (0, _objectSpread2["default"])({
                name: {
                  first: {
                    type: String
                  }
                },
                email: {
                  type: String
                },
                emailConfirmed: {
                  type: Boolean,
                  value: true
                }
              }, rest.config && rest.config.requiredDataForStatus ? rest.config.requiredDataForStatus : {})
            }
          }));
          var defaultAuthenticationObject = Object.create(Object.prototype, {
            subscribeUpdateUser: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
              value: function subscribeUpdateUser() {
                var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _p$addRequestKeys = p.addRequestKeys,
                  addRequestKeys = _p$addRequestKeys === void 0 ? [] : _p$addRequestKeys,
                  _p$requestKeys = p.requestKeys,
                  requestKeys = _p$requestKeys === void 0 ? [name + "Login", name + "Logout", name + "Signup", name + "ResetPassword", name + "Save", name + "ChangeEmail", name + "EmailConfirmation", name + "DeleteAccount"].concat((0, _toConsumableArray2["default"])(addRequestKeys)) : _p$requestKeys,
                  _p$addRequestKeysForA = p.addRequestKeysForAdmin,
                  addRequestKeysForAdmin = _p$addRequestKeysForA === void 0 ? [] : _p$addRequestKeysForA,
                  _p$requestKeysForAdmi = p.requestKeysForAdmin,
                  requestKeysForAdmin = _p$requestKeysForAdmi === void 0 ? [name + "Save"].concat((0, _toConsumableArray2["default"])(addRequestKeysForAdmin)) : _p$requestKeysForAdmi;
                if (wapp.states) {
                  var statesHandleName = "subscribeFor" + name.slice(0, 1).toUpperCase() + name.slice(1);
                  wapp.states.addHandle((0, _defineProperty2["default"])({}, statesHandleName, function (req, res, next) {
                    var wappResponse = res.wappResponse;
                    var wappRequest = req.wappRequest;
                    if (client.authentications[name].unsubscribeUpdateUser) {
                      client.authentications[name].unsubscribeUpdateUser();
                    }
                    var unsubscribe = wappResponse.store.subscribe(function (_ref) {
                      var type = _ref.type,
                        payload = _ref.payload;
                      if (type === "INS_RES" && payload.name === "responses") {
                        var stateBeforeUserId = wappResponse.store.getState("req.user._id");
                        var stateBeforeUser = wappResponse.store.getState("req.user");
                        var response = payload.value;
                        var findByIdBeforeUpdate = wappResponse.store.getState("res.responses." + name + "FindById");
                        requestKeys.forEach(function (requestName) {
                          if (response && response[requestName] && typeof response[requestName].record !== "undefined" && !response[requestName].error) {
                            var _response$requestName;
                            var userId = (_response$requestName = response[requestName].record) === null || _response$requestName === void 0 ? void 0 : _response$requestName._id;
                            var isLogout = requestName === name + "Logout" || requestName === name + "DeleteAccount" && userId && stateBeforeUserId && stateBeforeUserId.toString() === userId.toString();
                            var shouldUpdateFindById = (findByIdBeforeUpdate === null || findByIdBeforeUpdate === void 0 ? void 0 : findByIdBeforeUpdate._id) === userId;
                            if (isLogout && userId) {
                              userId = null;
                            }
                            var changedUser = !(userId && stateBeforeUserId && stateBeforeUserId.toString() === userId.toString() || !userId && !stateBeforeUserId);
                            var changedData = userId && !changedUser && JSON.stringify(stateBeforeUser) !== JSON.stringify(response[requestName].record);
                            if (changedUser && stateBeforeUserId && userId && requestKeysForAdmin.indexOf(requestName) > -1) {
                              changedUser = false;
                            }
                            if (changedUser || changedData) {
                              var _response$requestName2;
                              var newUser = (_response$requestName2 = response[requestName].record) !== null && _response$requestName2 !== void 0 && _response$requestName2._id && !isLogout ? (0, _objectSpread2["default"])({}, response[requestName].record) : null;
                              wappResponse.store.dispatch(wapp.states.runAction("req", {
                                name: "user",
                                value: newUser
                              }));
                              if (shouldUpdateFindById) {
                                wappResponse.store.dispatch(wapp.states.stateManager.actions.res({
                                  type: "INS_RES",
                                  name: "responses",
                                  value: (0, _defineProperty2["default"])({}, name + "FindById", newUser)
                                }));
                              }
                              wappRequest.user = newUser;
                              req.user = wappRequest.user;
                            }
                          }
                        });
                      }
                    });
                    client.authentications[name].unsubscribeUpdateUser = function () {
                      unsubscribe();
                      client.authentications[name].unsubscribeUpdateUser = null;
                    };
                    next();
                  }));
                }
              }
            }),
            unsubscribeUpdateUser: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
              value: null
            })
          });
          (0, _utils.mergeProperties)(defaultAuthenticationObject, postType);
          Object.defineProperty(client.authentications, name, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
            writable: false,
            value: defaultAuthenticationObject
          }));
          client.authentications[name].subscribeUpdateUser({
            addRequestKeys: addRequestKeys,
            requestKeys: requestKeys,
            addRequestKeysForAdmin: addRequestKeysForAdmin,
            requestKeysForAdmin: requestKeysForAdmin
          });
          return client.authentications[name];
        }
      }),
      getAuthentication: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
        writable: false,
        enumerable: false,
        value: function getAuthentication() {
          var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _p$name2 = p.name,
            name = _p$name2 === void 0 ? "user" : _p$name2,
            addIfThereIsNot = p.addIfThereIsNot,
            rest = (0, _objectWithoutProperties2["default"])(p, _excluded2);
          var auth = client.authentications[name];
          if (auth || !addIfThereIsNot) {
            return auth;
          }
          return client.authentications.addAuthentication((0, _objectSpread2["default"])({
            name: name
          }, rest));
        }
      })
    });
    Object.defineProperty(client, "authentications", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultAuthenticationsObject
    }));
    Object.defineProperty(client.authentications, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }));
    (0, _addStatesHandle["default"])({
      wapp: wapp
    });
  }
  return client.authentications;
}